import { render } from "./BaseGoBack.vue?vue&type=template&id=3f43be6a&ts=true"
import script from "./BaseGoBack.vue?vue&type=script&lang=ts"
export * from "./BaseGoBack.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__